import {addWindowEventListener, removeWindowEventListener} from './windowUtils';

interface EventListener {
  eventName: string;
  func: EventListenerOrEventListenerObject;
}

export class WindowEventTracker {
  private trackedObjects: EventListener[] = [];

  addEventListener(eventName: string, func: EventListenerOrEventListenerObject) {
    this.trackedObjects.push({eventName, func});
    addWindowEventListener(eventName, func);
  }

  release() {
    while (this.trackedObjects.length !== 0) {
      const obj = this.trackedObjects.pop();
      if (obj === undefined) {
        continue;
      }

      removeWindowEventListener(obj.eventName, obj.func);
    }
  }
}
